var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('transaction-details-template', {
    attrs: {
      "header-icon": "finance_creditcard-income"
    },
    on: {
      "close": function close($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    domProps: {
      "textContent": _vm._s(_vm.displayTitle)
    },
    slot: "title"
  }), _vm.isProcessingSafeDeal ? _c('div', {
    directives: [{
      name: "d-flex",
      rawName: "v-d-flex"
    }, {
      name: "opacity",
      rawName: "v-opacity",
      value: .65,
      expression: ".65"
    }],
    attrs: {
      "slot": "summary"
    },
    slot: "summary"
  }, [_c('base-icon', {
    directives: [{
      name: "m-r",
      rawName: "v-m-r",
      value: 5,
      expression: "5"
    }],
    attrs: {
      "size": 16,
      "name": "basic_lock-outline"
    }
  }), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.displayAmount)
    }
  })], 1) : _c('span', {
    attrs: {
      "slot": "summary"
    },
    domProps: {
      "textContent": _vm._s(_vm.displayAmount)
    },
    slot: "summary"
  }), _c('template', {
    slot: "content"
  }, [_vm.isSetupPayment ? _c('div', {
    class: _vm.$style.setup
  }, [_c('h4', {
    domProps: {
      "textContent": _vm._s(_vm.$t('transaction.header.setup.payment'))
    }
  }), _c('help-link', {
    directives: [{
      name: "color",
      rawName: "v-color",
      value: 'violet',
      expression: "'violet'"
    }],
    attrs: {
      "source": "https://help.capusta.space/bill/setup_payment"
    }
  })], 1) : _vm._e(), _vm.isShownSafeDeal ? [_c('transaction-safe-deal', {
    attrs: {
      "deal": _vm.transaction.deal,
      "permission": _vm.permission
    }
  }), _c('hr', {
    class: _vm.$style.delimiter
  })] : _vm._e(), _c('sender-information', {
    attrs: {
      "sender": _vm.senderContent,
      "payment": _vm.paymentContent,
      "rating": _vm.ratingContent
    }
  }), _vm.transaction.commission ? [_c('hr', {
    class: _vm.$style.delimiter
  }), _c('transaction-commission', {
    attrs: {
      "commission": _vm.transaction.commission,
      "currency": _vm.transaction.currency
    }
  })] : _vm._e(), _vm.isShownDescription ? [_c('hr', {
    class: _vm.$style.delimiter
  }), _c('transaction-description', {
    attrs: {
      "description": _vm.transaction.description,
      "additional-params": _vm.transaction.additional_params
    }
  })] : _vm._e(), _vm.isShownBillTariff ? [_c('hr', {
    class: _vm.$style.delimiter
  }), _c('purchase-bill-tariff', {
    attrs: {
      "transaction": _vm.transaction
    }
  })] : _vm.transactionTips ? [_c('hr', {
    class: _vm.$style.delimiter
  }), _c('applied-transaction-tips', {
    attrs: {
      "variant": _vm.transactionTips
    }
  })] : _vm._e(), _vm.isShownDeclaration ? [_c('hr', {
    class: _vm.$style.delimiter
  }), _c('transaction-declaration', {
    attrs: {
      "transaction": _vm.transaction,
      "permission": _vm.permission
    }
  })] : _vm._e()], 2), _vm.permission ? _c('div', {
    class: _vm.$style.footer,
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_vm.isShownRefundButton ? _c('refund-button', {
    attrs: {
      "public-id": _vm.transaction.public_id
    }
  }) : _vm._e(), _vm.isShownRefundedInfoButton ? _c('refunded-info-button', {
    attrs: {
      "public-id": _vm.transaction.public_id
    }
  }) : _vm._e(), _c('receipt-sender-button', {
    attrs: {
      "description": _vm.PROJECT_INFO.description,
      "pay-link": _vm.PROJECT_INFO.payLink,
      "public-id": _vm.transaction.public_id
    }
  })], 1) : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }